import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from '../decorators';
import { RemoteGetLocationUsers } from 'data/usecases/remote-get-location-users';
import { GetLocationUsers } from 'domain/usecases/get-location-users';

export const makeRemoteGetLocationsUsers = (): GetLocationUsers => {
  return new RemoteGetLocationUsers(makeApiUrl('/getLocationUsers'), makeAuthorizeHttpClientDecorator());
};
